/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationSubscription200ResponseAddonsInner
 */
export interface GetLocationSubscription200ResponseAddonsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLocationSubscription200ResponseAddonsInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetLocationSubscription200ResponseAddonsInner
     */
    price: number;
}

/**
 * Check if a given object implements the GetLocationSubscription200ResponseAddonsInner interface.
 */
export function instanceOfGetLocationSubscription200ResponseAddonsInner(value: object): value is GetLocationSubscription200ResponseAddonsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function GetLocationSubscription200ResponseAddonsInnerFromJSON(json: any): GetLocationSubscription200ResponseAddonsInner {
    return GetLocationSubscription200ResponseAddonsInnerFromJSONTyped(json, false);
}

export function GetLocationSubscription200ResponseAddonsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationSubscription200ResponseAddonsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'price': json['price'],
    };
}

export function GetLocationSubscription200ResponseAddonsInnerToJSON(json: any): GetLocationSubscription200ResponseAddonsInner {
    return GetLocationSubscription200ResponseAddonsInnerToJSONTyped(json, false);
}

export function GetLocationSubscription200ResponseAddonsInnerToJSONTyped(value?: GetLocationSubscription200ResponseAddonsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'price': value['price'],
    };
}

